export default __webpack_public_path__ + "media/images/info_alerte_16-3b889c4ec526b959077e2aa06f8ca05b.png";